// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"608":"addea741","930":"1fbdf8b9"}[chunkId] + ".chunk.js";
};